// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn light color="success" @click="attemptSave()">Save</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="formValid" ref="form">
          <v-row wrap>
            <v-col cols="12">
              <v-row>
                <v-text-field
                v-model.number="settings.daysDelete"
                append-icon="clear"
                @click:append="(event) => settings.daysDelete = 0"
                label="Delete Age (days)"
                :rules="[ruleRequired, rulePosInteger]"
                type="number"
                ></v-text-field>
                <v-menu open-on-hover left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" slot="activator"><v-icon>help_outline</v-icon></v-btn>
                  </template>
                  <v-card><v-card-text>
                    Images more than this many days old will be permanently deleted. <b>Do not set this parameter unless you know what you are doing!</b>
                  </v-card-text></v-card>
                </v-menu>
              </v-row>
            </v-col>
            <!-- <v-flex xs12>
              <v-layout row>
                <v-text-field
                v-model.number="settings.daysHide"
                append-icon="clear"
                @click:append="(event) => settings.daysHide = 0"
                label="Archive Age (days)"
                :rules="[ruleRequired, rulePosInteger]"
                type="number"
                ></v-text-field>
                <v-menu open-on-hover left>
                  <v-btn icon slot="activator"><v-icon>help_outline</v-icon></v-btn>
                  <v-card><v-card-text>
                    Images more than this many days old will be archived.
                  </v-card-text></v-card>
                </v-menu>
              </v-layout>
            </v-flex> -->
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showSaveDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Save Changes?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to make changes to the settings?  Some settings may cause images to be irrevocably deleted.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showSaveDialog = false">Cancel</v-btn>
          <v-btn text color="red" @click="save">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
import Rules from 'vue-common/components/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      errorText: '',
      formValid: true,
      ruleRequired: Rules.required,
      settings: {},
      showSaveDialog: false
    }
  },

  created () {
    ApiRequests.getSettings().then(r => {
      this.settings = r.data
    })
  },

  methods: {
    attemptSave: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        this.showSaveDialog = true
      }
    },

    save: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        ApiRequests.putSettings(this.settings).then(r => {
          this.errorText = 'Settings saved'
          this.settings = r.data
          this.showSaveDialog = false
        }).catch(e => {
          this.errorText = 'Error saving settings: ' + e
          this.showSaveDialog = false
        })
      }
      this.errorText = 'Please make sure all fields are correct before saving.'
    },

    rulePosInteger: function (value) {
      if (value > -1) {
        return true
      } else {
        return 'This field must contain a positive integer'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Settings.vue?5ec04cfd